module.exports = __webpack_public_path__ + "static/media/placeholder_image_fff.ff79a807.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placeholder_image_fff.jpg
// module id = 493
// module chunks = 0